import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import EditableCell from './EditableCell';

class VirtualRow extends Component {

    handleChange = (record) => {
        this.props.onChange && this.props.onChange(record);
    }

    handleChangeCalc = (record) => {
        this.props.onChangeCalc && this.props.onChangeCalc(record)
    }

    renderBodyCells(record) {
        const { columns } = this.props;
        return _.map(
            columns,
            column => (
                <td key={column.dataIndex} style={{ minWidth: column.width }}>
                    <EditableCell 
                        record={record} 
                        column={column} 
                        onChange={this.handleChange} 
                        onChangeCalc={this.handleChangeCalc}
                    />
                </td>
            )
        )
    }

    render() { 
        const { record } = this.props;
        return <tr key={record.id}>
            {this.renderBodyCells(record)}
        </tr>
    }
};

const mapStateToProps = (state, props) => {
    const { source } = state.buhtable;
    return {
        record: source[props.index] && source[props.index]
    }
}
 
export default connect(mapStateToProps)(VirtualRow);


// WEBPACK FOOTER //
// ./src/components/VirtualTable/VirtualRow.jsx